function decimalsCurrencyFormat(value) {
  const dollars = Math.floor(value / 100);
  const cents = String(value % 100).padStart(2, "0");
  const dollarsFormat = new Intl.NumberFormat("en-US").format(dollars);
  const priceFormat = `${dollarsFormat}${cents != 0 ? `.${cents}` : ""}`;
  return priceFormat;
}

function updateElement(element, value) {
  if (element instanceof NodeList) {
    element.forEach(el => el.innerHTML = value);
  } else if (element) {
    element.innerHTML = value;
  }
}

function updatePrice(e) {

  e.stopPropagation();
  e.stopImmediatePropagation();
  let currentVariant = e.detail.variant;

  const formId = e.target.getAttribute("id");
  const formScope = `price-list:has(sale-price[form="${formId}"])`;

  let priceOldSpan = document.querySelectorAll(`${formScope} sale-price div`);
  let priceSpan = document.querySelectorAll(`${formScope} .product_price__original`);
  let discountSpan = document.querySelectorAll(
    `${formScope} .product_price__discount_percentage`
  );
  let compareSpan = document.querySelectorAll(`${formScope} .product_price__discount`);

  // Update price
  updateElement(priceSpan, `$${decimalsCurrencyFormat(currentVariant.price)}`);
  updateElement(priceOldSpan, `$${decimalsCurrencyFormat(currentVariant.price)}`);

  // Update discount and compare price
  if (
    currentVariant.compare_at_price &&
    currentVariant.compare_at_price > currentVariant.price
  ) {
    let discount =
      ((currentVariant.compare_at_price - currentVariant.price) /
        currentVariant.compare_at_price) *
      100;
    updateElement(discountSpan, `(${Math.round(discount)}% OFF)`);
    updateElement(compareSpan, `$${decimalsCurrencyFormat(
      currentVariant.compare_at_price
    )}`);
  } else {
    updateElement(discountSpan, "");
    updateElement(compareSpan, "");
  }
}

document.addEventListener("variant:change", updatePrice);
